'use client';
import { useState } from "react";
import { useProfileStore } from "../store/useProfileStore";
import { useEdTechProductStore } from "../store/useEdTechProductStore";
import { getCourseRefreshToken } from "../api/course/getCourseRefreshToken";

interface CourseRefreshTokenHook {
    fetchCourseUrl: (courseId: string) => Promise<void>;
    isLoading: boolean;
  }
  
  export const useCourseRefreshToken = (): CourseRefreshTokenHook => {
    const [isLoading, setIsLoading] = useState<boolean>(false);
    const userprofile = useProfileStore((state) => state.userProfile);
    const setLearningCourseWebViewUrl = useEdTechProductStore((state) => state.setLearningCourseWebViewUrl);
  
    const fetchCourseUrl = async (courseId: string) => {
      let payload = {
        courseId,
        buyerName: userprofile?.user?.name,
        buyerId: userprofile?.user?.id,
      };
  
      setIsLoading(true);
      try {
        const response = await getCourseRefreshToken(payload);
        setLearningCourseWebViewUrl(response?.data?.url);
      } catch (err: any) {
        console.error("Error fetching course refresh token  url:", err);
      } finally {
        setIsLoading(false);
      }
    };
  
    return { fetchCourseUrl, isLoading };
  };
  